// Pestañas de la app «Atención Ciudadana» (mismo patrón OsTabs que Leads/Deals).
// Cada pestaña es una ruta del módulo, así que se comparte el enlace y el menú
// lateral marca la misma.
import { useNavigate } from 'react-router-dom';
import { Inbox, MapPin } from 'lucide-react';

import { OsTabs } from '@/modules/orion-shell/OsApp';

export type CitizenTab = 'dashboard' | 'buzones';

export function CitizenTabs({ value }: { value: CitizenTab }) {
  const navigate = useNavigate();
  return (
    <OsTabs<CitizenTab>
      label="Secciones de Atención Ciudadana"
      value={value}
      onChange={(t) => navigate(`/m/citizen-reports/${t}`)}
      items={[
        { key: 'dashboard', label: 'Inteligencia urbana', icon: MapPin },
        { key: 'buzones', label: 'Tickets', icon: Inbox },
      ]}
    />
  );
}
